const Footer = () => {
  return (
    <div className="footer-container">
      <img className="footer-logo" alt="logo" />
      <p className='footer-text'>Powered by Cogitus</p>
    </div>
  )
}

export default Footer